import React, { useRef, useEffect, useCallback, useState} from 'react';
import {setTrackerParameterToEdit} from 'actions/index.js';
import Tracker from './Tracker.js';
import {connect} from 'react-redux';

const GroupTracker = ({group, currentStep, setParameterToEdit, cursorStep, playing}) => { 
    const ref = useRef(ref);
    const [step, setStep] = useState(undefined);
    const [isScrolling, setIsScrolling] = useState(false);

    useEffect(() => {
        if (currentStep === 0) {
            setStep(undefined);
            setIsScrolling(false);
        }
    }, [currentStep, setStep, setIsScrolling]);

    useEffect(() => {
        setStep(undefined);
        setIsScrolling(false);
    }, [playing, setStep, setIsScrolling]);

    const onScroll = useCallback((e) => {
        let stepToSet = Math.min(group.sequencerEngine.length, Math.max(0, (step || currentStep) + e.deltaY/8.0));
        setStep(stepToSet);
        setIsScrolling(true);
    }, [setStep, step, currentStep, setIsScrolling]);

    useEffect(() => {
        ref.current.addEventListener("mousewheel", onScroll);

        return () => ref.current.removeEventListener("mousewheel", onScroll);
    }, [setStep, step, currentStep, setIsScrolling]);

    const onMouseLeave = useCallback(() => {
        setStep(undefined);
        setParameterToEdit(undefined);
    }, [setStep, setParameterToEdit]);

    useEffect(() => {
        setStep(cursorStep);
    }, [cursorStep, setStep]);

    let track = group.sequencerEngine.getSelectedTrack();

    useEffect(() => {
        if (step === undefined || isScrolling || !track) {
            return;
        }
        let _step = step || currentStep;
        if (_step > cursorStep || cursorStep >= (_step + 4) % track.length) {
            _step = cursorStep - 3;
            if (_step < 0) {
                _step = track.length + _step;
            } else {
                _step = _step % track.length;
            }
            setStep(_step);
        }
    }, [step, cursorStep, setStep, isScrolling, track]);

    return (
        <div onMouseLeave={onMouseLeave} ref={ref} className="group-tracker">
          {group.tracks.map(
              track => <Tracker
                         pattern={track.pattern}
                         step={Math.floor(step)}
                         cursorStep={cursorStep}
                         currentStep={currentStep}
                         key={track.id}
                         track={track}/>)}
        </div>);
}

const mapStateToProps = (state, props) => {
    var currentStep = Math.floor(
        (props.group.sequencerEngine.lastTrackStep || 0));
    let cursor = props.group.sequencerEngine.cursor;
    return {
        currentStep: Math.floor(currentStep / 2),
        pattern: props.group.tracks[0] && props.group.tracks[0].pattern,
        cursorStep: cursor.step / 2,
        playing: props.group.sequencerEngine.playing
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setParameterToEdit: (param) => dispatch(setTrackerParameterToEdit(param))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GroupTracker);
